/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2023 Deere & Company

import React, { Component } from 'react';
import File from '../../../sharedmodules/state/file';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { downloadFile } from '../services/file-download';

class Attachments extends Component {

    constructor() {

        super();
        this.onFileClick = this.onFileClick.bind(this);

    }

    onFileClick(file) {

        downloadFile(this.props.auth.getAccessToken, file);

    }

    render() {

        return (
            <div className="attachments">
                <h4>
                    <FormattedMessage id="ATTACHMENTS" />
                </h4>
                <ul>
                    {this.props.files.map((file, index) => (
                        <li key={index}>
                            <button
                                className="button-text"
                                onClick={this.onFileClick.bind(null, file)}
                            >
                                {file.fileName}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        );

    }

}
Attachments.displayName = 'Attachments';
Attachments.propTypes = {
    auth: PropTypes.object.isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
};

export default Attachments;
